var React = require('react');

function AttachmentIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"path-1_1_","fill":"#414042","d":"M9.225,17C6.752,17,4,15.062,4,12.641V5.321h1.495v7.319c0,1.615,2.081,2.896,3.73,2.896\r\n\tc1.65,0,3.28-1.313,3.28-2.928V4.191c0-1.009-1.255-1.727-2.284-1.727c-1.031,0-2.046,0.718-2.046,1.727v6.954\r\n\tc0,0.403,0.336,0.732,0.748,0.732s0.748-0.329,0.748-0.732V5.289h1.495v5.855c0,1.211-1.006,2.195-2.243,2.195\r\n\tc-1.237,0-2.243-0.984-2.243-2.195V4.191C6.679,2.375,8.365,1,10.221,1C12.075,1,14,2.375,14,4.191v8.417\r\n\tC14,15.031,11.699,17,9.225,17z"}));
}

AttachmentIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"18px","height":"18px","viewBox":"0 0 18 18","enableBackground":"new 0 0 18 18","xmlSpace":"preserve"};

module.exports = AttachmentIcon;

AttachmentIcon.default = AttachmentIcon;
